import { render, staticRenderFns } from "./CampaignMail.vue?vue&type=template&id=34e4a9d1&scoped=true&"
import script from "./CampaignMail.vue?vue&type=script&lang=js&"
export * from "./CampaignMail.vue?vue&type=script&lang=js&"
import style0 from "./CampaignMail.vue?vue&type=style&index=0&id=34e4a9d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e4a9d1",
  null
  
)

export default component.exports